import React from 'react';
import styled from 'styled-components';
const OneTrustSDKButton = () => (React.createElement(StyledButton, { id: "ot-sdk-btn", className: "ot-sdk-show-settings" }, "Cookies Settings"));
export default OneTrustSDKButton;
// !important is needed to overwrite the default sdk button styles
const StyledButton = styled.a `
  padding: 0 !important;
   
  text-decoration: none !important;
  
  cursor: pointer !important;

  font-family: ${props => props.theme.fonts.regular} !important;
  font-size: 11px !important;
  line-height: inherit !important;
  
  border: none !important;
  
  background-color: inherit !important;
  color: ${props => props.theme.colors.footerLinkGray} !important;
`;
//# sourceMappingURL=OneTrustSDKButton.js.map